import {Component, Input, ChangeDetectionStrategy} from '@angular/core';
import {BerthVisit, TerminalVisit} from "@portbase/bezoekschip-service-typescriptmodels";
import {PortvisitUtils} from "../../../../../refdata/portvisit-utils";

@Component({
    selector: 'app-terminal-planning-number-info',
    templateUrl: './terminal-planning-number-info.component.html',
    styleUrls: ['./terminal-planning-number-info.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class TerminalPlanningNumberInfoComponent {
  @Input() terminalVisit: TerminalVisit;
  @Input() berthVisit: BerthVisit;
  @Input() required: boolean;

  get includeRestowInLoadAndDischarge() {
    return (PortvisitUtils.restowDisabledOrganisations.includes(this.terminalVisit?.organisationShortName) ||
      PortvisitUtils.restowDisabledOrganisations.includes(this.berthVisit?.stevedore?.shortName));
  }

  get expectedLoad() {
    return this.terminalVisit?.info?.expectedLoad
      ? this.terminalVisit.info.expectedLoad - (this.includeRestowInLoadAndDischarge
      ? this.terminalVisit?.info?.expectedRestow || this.berthVisit.restow : 0) : undefined;
  }

  get expectedDischarge() {
    return this.terminalVisit?.info?.expectedDischarge
      ? this.terminalVisit.info.expectedDischarge - (this.includeRestowInLoadAndDischarge
      ? this.terminalVisit?.info?.expectedRestow || this.berthVisit.restow : 0) : undefined;
  }
}
